/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum SystemTypeReportRepresentations {
    Windows = 0,
    Linux = 1,
    Mac = 2,
}
